import React, { createContext, useContext, useState, useCallback } from 'react';
import { Alert } from '@ann/web-components';

const AutosaveContext = createContext();

export const useAutosaveContext = () => {
  const context = useContext(AutosaveContext);
  if (!context) {
    throw new Error('useAutosaveContext must be used within an AutosaveProvider');
  }
  return context;
};

export const AutosaveProvider = ({ children }) => {
  const [notification, setNotification] = useState(null);
  const [globalError, setGlobalError] = useState(null);
  const [globalIsSaving, setGlobalIsSaving] = useState(false);

  const showNotification = useCallback((message, type = 'success') => {
    setNotification({
      title: type === 'success' ? 'Changes saved' : 'Error saving',
      message: message,
      severity: type
    });

    // Auto-hide after 3 seconds
    setTimeout(() => {
      setNotification(null);
    }, 3000);
  }, []);

  const hideNotification = useCallback(() => {
    setNotification(null);
  }, []);

  const setError = useCallback((error) => {
    setGlobalError(error);
    showNotification(error, 'error');
  }, [showNotification]);

  const clearError = useCallback(() => {
    setGlobalError(null);
  }, []);

  const setSaving = useCallback((isSaving) => {
    setGlobalIsSaving(isSaving);
  }, []);

  const value = {
    notification,
    showNotification,
    hideNotification,
    globalError,
    setError,
    clearError,
    globalIsSaving,
    setSaving
  };

  return (
    <AutosaveContext.Provider value={value}>
      {children}
      {notification && (
        <Alert
          title={notification.title}
          description={notification.message}
          severity={notification.severity}
          width="692px"
          top="61px"
          right="16px"
          onClose={hideNotification}
        />
      )}
    </AutosaveContext.Provider>
  );
}; 